const hasSoldOutMessage = ( soldOutReason: string, isWhitelabel: boolean, isLiveClass: boolean ) =>
  soldOutReason === 'Sold Out' || ( soldOutReason === 'Waitlist' && ( isWhitelabel || isLiveClass ));

export default hasSoldOutMessage;
